export const inferSecondHandCategory = (doc = {}) => {
  if (["iPhone", "iPad", "Android", "iWatch", "Airpods"].includes(doc.category)) {
    return doc.category;
  }
  const name = String(doc.productName || doc.phone || "");
  if (/ipad/i.test(name)) return "iPad";
  if (/iphone/i.test(name)) return "iPhone";
  return "Android";
};

export const getSecondHandProductName = (doc = {}) =>
  doc.productName || doc.phone || "Unknown product";

export const getSecondHandVariant = (doc = {}) => {
  const category = inferSecondHandCategory(doc);
  if (category === "iWatch") {
    return [doc.watchType, doc.watchSize].filter(Boolean).join(", ") || "Default";
  }
  if (category === "Airpods") return "Default";
  return doc.storage || "Default";
};

export const formatSecondHandProduct = (doc = {}) => {
  const name = getSecondHandProductName(doc);
  const variant = getSecondHandVariant(doc);
  return variant === "Default" ? name : `${name} (${variant})`;
};

export const secondHandInventoryKey = (doc = {}) =>
  `${inferSecondHandCategory(doc)}|${formatSecondHandProduct(doc)}`;
